import { useEffect } from "react";
import { useRawTable } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setDiagramFilter } from "../../../redux/slice/diagram";
import moment from "moment";

export default function Module_HepatitisTracking_CaseVisitDetail({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  totalRecord,
  callMainAPI,
  isResetPage,
}) {
  const dispatch = useDispatch();
  const redux_diagram = useSelector((state) => state.diagram);
  const { tbData, setTbData, setTbFirstIndex, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (
      !apiData ||
      redux_diagram.filterSetting.CaseVisitDetail ||
      redux_diagram.filterSetting.CaseVisitDetail === null
    )
      return;

    let thisYear = Number(moment().format("YYYY"));
    let filterData = {
      ...redux_diagram.filterSetting,
      CaseVisitDetail: {
        篩檢日期: {
          type: "date",
          value: [thisYear],
        },
      },
    };
    dispatch(setDiagramFilter(filterData));
  }, [apiData, redux_diagram]);

  useEffect(() => {
    if (!isResetPage) return;

    setTbFirstIndex(0);
  }, [isResetPage]);

  useEffect(() => {
    if (
      !apiData ||
      (!redux_diagram.filterSetting.CaseVisitDetail &&
        redux_diagram.filterSetting.CaseVisitDetail !== null)
    )
      return;

    const formatDetail = (data) => {
      if (!data) return null;

      return data.map((item) => ({
        ...item,
        篩檢日期: item["篩檢日期"]
          ? moment(item["篩檢日期"]).format("YYYY-MM-DD")
          : "-",
      }));
    };

    setTbData({
      raw: formatDetail(apiData),
      format: null,
      export: formatDetail(exportData),
      totalRecord,
    });
  }, [apiData, exportData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
        isPaginator: true,
        callMainAPI,
        exportData,
      })}
    </>
  );
}
